// TanStack Query key factory for the member entity. Keeping the keys here
// lets future server-state mutations (e.g. an opt-out action surfaced from
// settings) invalidate the list without reaching into hook internals.
//
// Stages are part of the cache key so toggling filter chips refetches the
// correct slice rather than reusing a cached page that was filtered
// differently. Stages are sorted before being interned so the same chip
// selection always produces the same key regardless of toggle order.

import type { MemberLifecycleStage } from "@community-analytics/shared";

export const memberQueryKeys = {
  all: ["member"] as const,
  list: (communityId: string, stages: ReadonlyArray<MemberLifecycleStage>) =>
    [
      ...memberQueryKeys.all,
      "list",
      communityId,
      [...stages].sort().join(",") || "__all__",
    ] as const,
  // TASK-033 — lifecycle trend (30-day stage distribution). Keyed only by
  // communityId because the trend window is fixed (last 30 days, server-
  // anchored to `now`). When TASK-052 / TASK-033's date-range follow-up
  // adds a window picker, extend the key tuple here.
  lifecycle: (communityId: string) =>
    [...memberQueryKeys.all, "lifecycle", communityId] as const,
} as const;
